import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { ProjectContext } from "../App"
import { resolveOptionalColor, resolveThemeColor } from "../utils/buttonColor"

export default function Footer() {
  const { project } = useContext(ProjectContext)
  const { t } = useTranslation('common')

  return (
    <footer
      className="py-3 text-center w-full"
      style={{
        backgroundColor: resolveThemeColor(project?.themeColor),
        color: resolveOptionalColor(project?.buttonColor) ?? '#FFFFFF'
      }}
    >
      <div className="mx-5">
        <h2 className="text-sm font-bold">
          {t('poweredBy')}{' '}
          <a
            className="inline-block underline-offset-2 hover:underline"
            href="https://www.batamx.co"
            target="_blank"
            rel="noopener noreferrer"
          >
            BatamX
          </a>
        </h2>
      </div>
    </footer>
  )
}
